import styled from 'styled-components';

import { default as ArrowComponent } from 'components/icons/DropdownArrow';
import { white, grey20, grey200, grey500 } from 'styles/colors';
import { mMedium, xxsRegularUppercase } from 'styles/typography';

export const Wrapper = styled.div`
	width: 100%;
`;

export const SelectWrapper = styled.div`
	position: relative;
	z-index: 0;
`;

export const StyledSelect = styled.select`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	outline: none;
	z-index: 1;
`;

export const SelectLabel = styled.span`
	position: relative;
	display: inline-block;
	padding: 7.5px 8.5px 6.5px 8.5px;
	width: 100%;
	border: 1px solid ${grey200};
	background-color: ${white};
	${mMedium};

	${StyledSelect}:focus + & {
		border: 1px solid ${grey500};
		background-color: ${grey20};
	}
`;

export const SelectLabelPlaceholder = styled(SelectLabel)`
	color: ${grey200};
	text-transform: capitalize;
`;

export const Arrow = styled(ArrowComponent)`
	position: absolute;
	right: 15px;
	top: 50%;
	margin-top: -2px;
	width: 10px;
	height: 5px;
	transform: rotate(180deg);
	opacity: ${props => (props.disabled ? '0.5' : '1')};
	color: ${grey200};
`;

export const Label = styled.label`
	text-overflow: ellipsis;
	margin-bottom: 8px;
	color: ${grey500};
	max-width: 100%;
	display: inline-block;
	white-space: nowrap;
	overflow: hidden;
	${xxsRegularUppercase};
`;
